import { ReactNode, Children } from 'react'

type FiltersWrapperProps = {
    children: ReactNode
    'data-testid'?: string
    alignLastRight?: boolean
}

const FiltersWrapper = ({ children, 'data-testid': dataTestId, alignLastRight = false }: FiltersWrapperProps) => {
    const items = Children.toArray(children)

    return (
        <div className="flex flex-wrap gap-4 items-center" data-testid={dataTestId}>
            {items.map((child, idx) => {
                const isLast = idx === items.length - 1
                const baseClasses = 'max-w-[210px] flex-1 min-w-[150px]'
                const extraClasses = alignLastRight && isLast ? 'ml-auto flex-initial' : ''

                return (
                    <div key={idx} className={`${baseClasses} ${extraClasses}`}>
                        {child}
                    </div>
                )
            })}
        </div>
    )
}

export default FiltersWrapper
